import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';

function UploadMemberDateTable({ failData }) {
    const [data, setData] = useState([]);

    useEffect(() => {
        const newData = failData.map(item => {
            const parsedValues = JSON.parse(item);
            return {
                status: parsedValues[45],
                reason: parsedValues[44],
                membershipNo: parsedValues[0],
                memberName: parsedValues[1],
                memberEmail: parsedValues[2],
                memberMobileNo: parsedValues[3],
                gender: parsedValues[4],
                dateofBirth: parsedValues[5],
                city: parsedValues[6],
                memberNetwork: parsedValues[7],
                contractNo: parsedValues[8],
                contractName: parsedValues[9],
                policyStartDate: parsedValues[10],
                policyEndDate: parsedValues[11],
                policyStatus: parsedValues[12],
                policyTotalMembers: parsedValues[13],
                policyMemberType: parsedValues[14],
                hof: parsedValues[15],
                height: parsedValues[16],
                weight: parsedValues[17],
                careProgram: parsedValues[18],
                chronicConditions: parsedValues[19],
                healthRiskCategory: parsedValues[20],
                healthRiskSegment: parsedValues[21],
                personalData: parsedValues[22],
                surgicalHistory: parsedValues[23],
                medicalHistory: parsedValues[24],
                commonChronicProfile: parsedValues[25],
                associatedChronic: parsedValues[26],
                topProvidersVisits: parsedValues[27],
                topSpecialtiesVisits: parsedValues[28],
                topDoctorsVisits: parsedValues[29],
                topConditionsByICD: parsedValues[30],
                opCostPerClaims: parsedValues[31],
                ipCostPerClaims: parsedValues[32],
                totalYtd: parsedValues[33],
                accomodation: parsedValues[34],
                consultation: parsedValues[35],
                medication: parsedValues[36],
                laboratories: parsedValues[37],
                advancedRadiology: parsedValues[38],
                surgicalProcedures: parsedValues[39],
                advancedServices: parsedValues[40],
                dental: parsedValues[41],
                otherServices: parsedValues[42],
            };
        });
        setData(newData);
    }, [failData]);

    const columnDefinitions = [
        { name: 'Status', key: 'status' },
        { name: 'Reason', key: 'reason' },
        { name: 'Membership No', key: 'membershipNo' },
        { name: 'Member Name', key: 'memberName' },
        { name: 'Member Email', key: 'memberEmail' },
        { name: 'Member Mobile No', key: 'memberMobileNo' },
        { name: 'Gender', key: 'gender' },
        { name: 'Date of Birth', key: 'dateofBirth' },
        { name: 'City', key: 'city' },
        { name: 'Member Network', key: 'memberNetwork' },
        { name: 'Contract No', key: 'contractNo' },
        { name: 'Contract Name', key: 'contractName' },
        { name: 'Policy Start Date', key: 'policyStartDate' },
        { name: 'Policy End Date', key: 'policyEndDate' },
        { name: 'Policy Status', key: 'policyStatus' },
        { name: 'Policy Total Members', key: 'policyTotalMembers' },
        { name: 'Policy Member Type', key: 'policyMemberType' },
        { name: 'HOF', key: 'hof' },
        { name: 'Height (cms.)', key: 'height' },
        { name: 'Weight (lbs.)', key: 'weight' },
        { name: 'Care Program', key: 'careProgram' },
        { name: 'Chronic Conditions', key: 'chronicConditions' },
        { name: 'Health Risk Category', key: 'healthRiskCategory' },
        { name: 'Health Risk Segment', key: 'healthRiskSegment' },
        { name: 'Personal Data', key: 'personalData' },
        { name: 'Surgical History', key: 'surgicalHistory' },
        { name: 'Medical History', key: 'medicalHistory' },
        { name: 'Common Chronic Profile', key: 'commonChronicProfile' },
        { name: 'Associated Chronic', key: 'associatedChronic' },
        { name: 'Top Providers Visits', key: 'topProvidersVisits' },
        { name: 'Top Specialties Visits', key: 'topSpecialtiesVisits' },
        { name: 'Top Doctors Visits', key: 'topDoctorsVisits' },
        { name: 'Top Conditions By ICD', key: 'topConditionsByICD' },
        { name: 'OP Cost Per Claims', key: 'opCostPerClaims' },
        { name: 'IP Cost Per Claims', key: 'ipCostPerClaims' },
        { name: 'Total YTD', key: 'totalYtd' },
        { name: 'Accomodation', key: 'accomodation' },
        { name: 'Consultation', key: 'consultation' },
        { name: 'Medication', key: 'medication' },
        { name: 'Laboratories', key: 'laboratories' },
        { name: 'Advanced Radiology', key: 'advancedRadiology' },
        { name: 'Surgical Procedures', key: 'surgicalProcedures' },
        { name: 'Advanced Services', key: 'advancedServices' },
        { name: 'Dental', key: 'dental' },
        { name: 'Other Services', key: 'otherServices' },

    ];

    const columns = columnDefinitions.map(col => ({
        name: col.name,
        selector: row => row[col.key],
        sortable: true,
        cell: row => (
          <div style={{ color: col.key === 'reason' || col.key === 'status' ? 'red' : 'inherit' }}>
            {col.key === 'reason' && row[col.key]
              ? row[col.key].split(',').map((item, index, array) => (
                  <React.Fragment key={index}>
                    {item}
                    {index < array.length - 1 ? ',' : ''}<br />
                  </React.Fragment>
                ))
              : row[col.key]}
          </div>
        ),
      }));

    const customStyles = {
        headCells: {
            style: {
                backgroundColor: '#D4E6EF',
                fontWeight: '500',
                fontSize: '14px',
                whiteSpace: 'normal',
            },
        },
        rows: {
            style: {
                whiteSpace: 'normal',
            },
        },
        cells: {
            style: {
                whiteSpace: 'normal',
            },
        },
    };

    return (
        <DataTable
            columns={columns}
            data={data}
            pagination
            paginationPerPage={10}
            striped
            responsive
            noHeader
            noFooter
            customStyles={customStyles}
        />
    );
}

export default UploadMemberDateTable;
